enum QueueTabsEnum {
  UP_NEXT = "UP_NEXT",
  RECENTLY_PLAYED = "RECENTLY_PLAYED",
  LEADERBOARD = "LEADERBOARD",
  HISTORY = "HISTORY",
}

export default QueueTabsEnum;
